import Timebar from './Timebar';
import OverlaySummary from './OverlaySummary';
import Hud from 'app/ui/hud/Hud';

import { FONT_TITLE, FONT_COPY } from 'app/constants/AppConstants';

export default class GameHud extends Phaser.Group {
  constructor(game) {
    super(game);

    // timebar
    this.timebar = new Timebar(this.game);
    this.timebar.y = 640;
    this.addChild(this.timebar);

    //
    this.setTime(1);

    this.game.onPause.add(this.handleGamePaused, this);
    this.game.onResume.add(this.handleGameResume, this);

    //
    this.game.scale.onSizeChange.add(this.positionElements, this);
    this.positionElements();

    // general hud
    this.genericHud = new Hud(this.game, Hud.MINIGAME);
    this.game.add.existing(this.genericHud);
  }

  positionElements() {
    this.x = this.game.width / 2;

    this.timebar.x = -this.timebar.bg.width / 2;

    //
    if (this.overlaySummary) {
      this.overlaySummary.x = (this.game.width - this.game.defaultWidth) / 2;
    }
  }

  setTime(value) {
    this.timebar.setValue(value);
  }

  showSummary() {
    this.overlaySummary = new OverlaySummary(this.game, this.genericHud);
    this.game.add.existing(this.overlaySummary);
    // this.game.world.bringToTop(this.genericHud);
    this.positionElements();
  }

  handleGamePaused() {
    if (this.overlaySummary) {
      this.overlaySummary.visible = false;
    }
  }

  handleGameResume() {
    if (this.overlaySummary) {
      this.overlaySummary.visible = true;
    }
  }

  destroy() {
    this.game.onPause.remove(this.handleGamePaused, this);
    this.game.onResume.remove(this.handleGameResume, this);

    this.genericHud.destroy();
    this.game.scale.onSizeChange.remove(this.positionElements, this);
    super.destroy();
  }
}



// WEBPACK FOOTER //
// ./js/app/games/chase/ui/GameHud.js